import { render, staticRenderFns } from "./GroupSwitcher.vue?vue&type=template&id=ced793c2&scoped=true&"
import script from "./GroupSwitcher.vue?vue&type=script&lang=js&"
export * from "./GroupSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./GroupSwitcher.vue?vue&type=style&index=0&id=ced793c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced793c2",
  null
  
)

export default component.exports